import React, { useEffect, useState, useRef } from 'react';

import { Container, Row, Col } from 'aplazame-design-system';

import CardClientStoryComponent from '../CardClientStoryComponent';




export default function VideoStoriesSection({
    videoStories
}) {
    return (
        <>
            <section>
                <Container 
                    pb={{ xs: 15, lg: 9 }}
                    pt={{ lg: 7 }}
                >
                    <Row>
                        {videoStories && videoStories.length ? (
                            videoStories.map((videoStories, i) => (
                                <Col
                                    key={i}
                                    col={{ md: 6, lg: 6 }}
                                    pb={{ xs: 7, lg: 8 }}
                                    data-sal="slide-up"
                                    data-sal-easing="ease-out-quart"
                                    data-sal-delay={`xs-none--lg-${(i % 3) * 200}`}
                                >
                                    <CardClientStoryComponent {...videoStories} />
                                </Col>
                            ))
                        ) : null}
                    </Row>
                </Container>
            </section>
        </>
    );
}